import { capitalizeFirstLetterSafe } from 'helpers/prepares'
import Button from 'ui/components/buttons/Button/'
import { Editor } from 'ui/components/forms/Editor'
import Input from 'ui/components/forms/Input/'
import Select from 'ui/components/forms/Select'
import { FormStyled, FieldsWrap, FieldsRow, ButtonsWrap } from './styled'

const Form = ({ formik, isLoading, taskTypeOptions, onClose }) => {
  const {
    values,
    errors,
    touched,
    handleSubmit,
    getFieldProps,
    setFieldValue,
    getFieldMeta,
  } = formik

  return (
    <FormStyled onSubmit={handleSubmit} noValidate>
      <FieldsWrap>
        <FieldsRow>
          <Select
            options={taskTypeOptions}
            id="taskTypeSelect"
            value={values.task_type}
            meta={getFieldMeta('task_type')}
            error={touched.task_type && errors.task_type}
            onChange={(newValue) =>
              setFieldValue('task_type', newValue || null)
            }
            label="Тип задачи"
            maxHeight="174px"
            placeholder="Не выбран"
          />

          <Input
            meta={getFieldMeta('name')}
            {...getFieldProps('name')}
            label="Название"
            placeholder="Введите название"
            id="templatesNameInput"
            disabled={isLoading}
            onChange={(e) => {
              const inputValue = e.target.value

              const formatted = capitalizeFirstLetterSafe(inputValue)

              setFieldValue('name', formatted)
            }}
          />
        </FieldsRow>

        <Editor
          name="content"
          id="templatesContent"
          label="Описание"
          meta={getFieldMeta('content')}
          value={values.content}
          onChange={(value) => setFieldValue('content', value)}
          disabled={isLoading}
        />
      </FieldsWrap>

      <ButtonsWrap>
        <Button title="Сохранить" type="submit" loading={isLoading} />
        <Button
          title="Отменить"
          type="button"
          theme="borderBlue"
          onClick={onClose}
        />
      </ButtonsWrap>
    </FormStyled>
  )
}

export default Form
